const footerLinks = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Hospitality", href: "#hospitality" },
  { label: "Contact", href: "#contact" },
  { label: "Privacy Policy", href: "#" },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          <div className="lg:col-span-2">
            <a href="#home" className="flex items-center gap-3 cursor-pointer">
              <span className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-restaurant-2-line text-background-50 text-lg"></i>
              </span>
              <span className="font-heading text-xl font-semibold text-background-50">
                RJB4 Restaurant Group, LLC
              </span>
            </a>
            <p className="mt-5 text-background-200/80 font-heading text-lg italic">
              Hospitality. Operations. Excellence.
            </p>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.25em] text-background-50/60 mb-4">
              Navigate
            </h4>
            <ul className="space-y-3">
              {footerLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-background-200/80 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.25em] text-background-50/60 mb-4">
              Contact
            </h4>
            <ul className="space-y-3 text-sm text-background-200/80">
              <li>
                <a
                  href="mailto:russell@rjb4restaurant.com"
                  className="hover:text-background-50 transition-colors cursor-pointer"
                >
                  russell@rjb4restaurant.com
                </a>
              </li>
              <li>
                <a
                  href="tel:+19493703217"
                  className="hover:text-background-50 transition-colors cursor-pointer"
                >
                  (949) 370-3217
                </a>
              </li>
              <li className="leading-relaxed">
                2 81 Via Guadix
                <br />
                Mission Viejo, CA 92691
                <br />
                United States
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-200/60">
            &copy; 2026 RJB4 Restaurant Group, LLC. All rights reserved.
          </p>
          <a
            href="#home"
            className="text-xs text-background-200/60 hover:text-background-50 transition-colors cursor-pointer"
          >
            Back to top &uarr;
          </a>
        </div>
      </div>
    </footer>
  );
}